<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="短信标题">
          <Input placeholder="请输入" v-model="table.search.SendTitle"></Input>
        </FormItem>
      </Form>
       <Button class="mr-3" type="success" @click="search">查询</Button>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>
      <!-- @selectionChange="selectionChange" -->

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="日志详情"
      :footer-hide="true"
      
      :closable="false"
      width="60%"
    >
      <logDetail v-if="detailModal" @close="detailModal=false" :currentData="currentData"></logDetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import logDetail from "../messagelog/detail.vue";

export default {
  components: { DataTable, logDetail },
  data: function () {
    return {
      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "短信标题", key: "sendTitle" },
          { title: "接收方", key: "reciveNumbers" },
          { title: "发送表述", key: "sendDescribtion" },
          {
            title: "发送状态",
            key: "sendFlag",
            width: "80px",
            render: (h, value) => {
              return h(
                "div",
                this.$common.getEnumDescription("SendFlag", value.row.sendFlag)
              );
            },
          },
          { title: "发送成功时间", key: "sendSuccesDate", width: "150px" },
          {
            title: "操作",
            width: "80px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
              ]);
            },
          },
        ],
        apiUrl: "log/getMessageLogList",
        search: {
          SendTitle: "",
        },
      },
    };
  },

  created: function () {
    //this.EmailSendFlagSelect = this.$common.getJsonData("EmailSendFlag");
  },
  activated(){
    this.search()
  },
  methods: {
    search: function () {
       this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
</style>